import { render, staticRenderFns } from "./Thesis.vue?vue&type=template&id=2c1e95a6&scoped=true"
import script from "./Thesis.vue?vue&type=script&lang=js"
export * from "./Thesis.vue?vue&type=script&lang=js"
import style0 from "./Thesis.vue?vue&type=style&index=0&id=2c1e95a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e95a6",
  null
  
)

export default component.exports